var map = {
	"./aplikacja-bankowa.jpg": "8tJW",
	"./bank.jpg": "xsNc",
	"./bankier.jpg": "8Qao",
	"./bankomat.jpg": "dY3R",
	"./budzet.jpg": "wyPH",
	"./gotowka.jpg": "8c1b",
	"./hologram.jpg": "Fbvb",
	"./inwestycja.jpg": "nOSx",
	"./kantor.jpg": "Bi4Q",
	"./karta-kredytowa.jpg": "CNP7",
	"./karta-platnicza.jpg": "gcqj",
	"./kieszonkowe.jpg": "kvIh",
	"./konto-bankowe.jpg": "51Um",
	"./limit-10-13.jpg": "Wgvy",
	"./limit-7-9.jpg": "R33L",
	"./limit.jpg": "6SKK",
	"./mennica.jpg": "OuSD",
	"./numer-konta-26-cyfr.jpg": "srV7",
	"./numer-pin.jpg": "9h+G",
	"./oszczednosci.jpg": "YDp9",
	"./pieniadz.jpg": "bn6k",
	"./platnosci-zblizeniowe.jpg": "IbEX",
	"./pozyczka.jpg": "A3iP",
	"./premia.jpg": "7sx2",
	"./przelew-internetowy.jpg": "dXRL",
	"./przelew-na-telefon.jpg": "KaXv",
	"./saldo.jpg": "2gFj",
	"./terminal-platniczy.jpg": "HJpP",
	"./transakcja.jpg": "iGhV",
	"./waluta.jpg": "8Kzo",
	"./wyciag-z-konta.jpg": "uWCO",
	"./wytwornia-papierow-wartosciowych.jpg": "Zeby"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "MALX";